class MellaProductProfile extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener('variant:update', (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const updated = event.detail.data.html?.querySelector(`mella-product-profile[data-product-id="${this.dataset.productId}"]`);
      if (updated) this.innerHTML = updated.innerHTML;
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('mella-product-profile')) customElements.define('mella-product-profile', MellaProductProfile);
